export enum GalaChainInfo {
  CHAIN_NAME = 'GalaChain',
}
